import { render, staticRenderFns } from "./CCardOld.vue?vue&type=template&id=5cbcd728"
import script from "./CCardOld.vue?vue&type=script&lang=js"
export * from "./CCardOld.vue?vue&type=script&lang=js"
import style0 from "./CCardOld.vue?vue&type=style&index=0&id=5cbcd728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports